<template>
    <el-container>
        <!-- 新建单位对话框 -->
        <el-dialog title="新建用户" :visible.sync="createDialog.dlgVisible">
            <el-form :model="createDialog" :rules="createRules" ref="createForm">
                <el-form-item label="用户姓名" prop="name" :label-width="createDialog.formLabelWidth">
                    <el-input v-model="createDialog.name" autocomplete="off" placeholder="请输入用户姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone" :label-width="createDialog.formLabelWidth">
                    <el-input v-model="createDialog.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="单位选择" prop="unId" :label-width="createDialog.formLabelWidth">
                    <el-select class="btnLeft" v-model="createDialog.unId" placeholder="请选择单位" filterable>
                        <el-option v-for="unit in data.units" :key="unit.id" :label="unit.name" :value="unit.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="成员描述" prop="description" :label-width="createDialog.formLabelWidth">
                    <el-input v-model="createDialog.description" autocomplete="off" placeholder="请输入成员描述"></el-input>
                </el-form-item>
                <el-form-item label="排序值" prop="orderNum" :label-width="createDialog.formLabelWidth">
                    <el-input v-model.number="createDialog.orderNum" autocomplete="off"
                        placeholder="请输入成员排序值"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createDialog.dlgVisible = false">取 消</el-button>
                <el-button type="primary" @click="createUser('createForm')">创 建</el-button>
            </div>
        </el-dialog>
        <!-- 编辑用户对话框 -->
        <el-dialog title="编辑用户信息" :visible.sync="updateDialog.dlgVisible">
            <el-form :model="updateDialog" :rules="createRules" ref="createForm">
                <el-form-item label="用户姓名" prop="name" :label-width="updateDialog.formLabelWidth">
                    <el-input v-model="updateDialog.name" autocomplete="off" placeholder="请输入用户姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone" :label-width="updateDialog.formLabelWidth">
                    <el-input v-model="updateDialog.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="单位选择" prop="unId" :label-width="updateDialog.formLabelWidth">
                    <el-select class="btnLeft" v-model="updateDialog.unId" placeholder="请选择单位" filterable>
                        <el-option v-for="unit in data.units" :key="unit.id" :label="unit.name" :value="unit.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="成员描述" prop="description" :label-width="updateDialog.formLabelWidth">
                    <el-input v-model="updateDialog.description" autocomplete="off" placeholder="请输入成员描述"></el-input>
                </el-form-item>
                <!-- <el-form-item label="用户状态" :label-width="updateDialog.formLabelWidth">
                    <el-input v-model="updateDialog.category" autocomplete="off"></el-input>
                </el-form-item> -->
                <el-form-item label="排序值" prop="orderNum" :label-width="updateDialog.formLabelWidth">
                    <el-input v-model.number="updateDialog.orderNum" autocomplete="off"
                        placeholder="请输入成员排序值"></el-input>
                </el-form-item>
                <el-form-item label="平台管理角色" :label-width="updateDialog.formLabelWidth">
                    <el-checkbox v-model="updateDialog.isAdmin" label="系统管理员"></el-checkbox>
                    <el-checkbox v-model="updateDialog.isSuper" label="平台管理员"></el-checkbox>
                    <el-checkbox v-model="updateDialog.isManager" label="单位管理员"></el-checkbox>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateDialog.dlgVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateUser">更 新</el-button>
            </div>
        </el-dialog>

        <el-header style="display: flex; align-items: center; justify-content: space-between">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>平台用户列表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button-group>
                <el-button type="info" icon="el-icon-magic-stick" @click.native="createDlgShow()">新建用户</el-button>
                <el-button type="info" icon="el-icon-menu" @click.native="toMoveUser()">转到移出用户列表</el-button>
                <el-button type="info" icon="el-icon-return" @click.native="formReturn()">返 回</el-button>
            </el-button-group>
        </el-header>
        <el-main>
            <div class="cust_seach">
                <el-select class="btnLeft" v-model="query.unId" placeholder="请选择单位" filterable @change="queryEmps">
                    <el-option v-for="unit in data.searchUnits" :key="unit.id" :label="unit.name" :value="unit.id" />
                </el-select>
                <el-input class="btnTitle" suffix-icon="el-icon-search" v-model="query.name" placeholder="输入姓名或部分"
                    @input="queryEmps"></el-input>
            </div>
            <el-table :data="data.emps" style="width: 100%" ref="EmpTable">
                <el-table-column type="index" align="center" width="100" :index="indexMethod" />
                <el-table-column align="left" property="name" label="姓名" width="100px" />
                <el-table-column align="left" property="phone" label="电话" width="150px" />
                <el-table-column align="left" property="unitName" label="单位" />
                <el-table-column align="left" property="roles" label="平台管理员角色" />
                <el-table-column align="left" property="officeName" label="成员描述" />
                <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <span>
                            <el-link icon="el-icon-edit-outline" @click="updateDlgShow(scope.row)">编辑</el-link>
                        </span>
                        <span style="margin-left: 10px;">
                            <el-link icon="el-icon-key" @click="resetPassword(scope.row)">重置</el-link>
                        </span>
                        <span style="margin-left: 10px;">
                            <el-link icon="el-icon-position" @click="movetoUser(scope.row)">移出</el-link>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination layout="prev,pager, next" :total="xpagination.totalCount" :page-size="xpagination.pageSize"
                @current-change="handleCurrentChange" hide-on-single-page :background="true">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
export default {
    created() {
        this.pstApi.setWindowTitle("平台用户管理");
        this.getUnitAll()
        this.getEmployes();
    },
    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号'));
            } else {
                var isPhone =
                    /^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(
                        value
                    );
                if (!isPhone) {
                    callback(new Error('手机号不合法'));
                }
                callback();
            }
        };
        return {
            createDialog: {
                dlgVisible: false,
                formLabelWidth: '120px',
                name: "",
                unId: "",
                phone: "",
                description: "",
                orderNum: 0,
            },
            createRules: {
                name: [
                    { required: true, message: '请输入用户姓名', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 个以上字符', trigger: 'blur' }
                ],
                unId: [
                    { required: true, message: '请选择单位', trigger: 'change' },
                ],
                phone: [
                    { required: true, message: '手机号不能为空', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                orderNum: [
                    { required: true, message: '排序值不能为空', trigger: 'blur' },
                    { type: 'number', message: '排序值必须为数字值' }
                ],
            },
            updateDialog: {
                dlgVisible: false,
                formLabelWidth: '120px',
                uid: "",
                name: "",
                unId: "",
                phone: "",
                description: "",
                category: 0,
                orderNum: 0,
                roles: "",
                isAdmin: false,
                isSuper: false,
                isManager: false
            },
            updateRules: {
                name: [
                    { required: true, message: '请输入用户姓名', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 个以上字符', trigger: 'blur' }
                ],
                unId: [
                    { required: true, message: '请选择单位', trigger: 'change' },
                ],
                phone: [
                    { required: true, message: '手机号不能为空', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                orderNum: [
                    { required: true, message: '排序值不能为空', trigger: 'blur' },
                    { type: 'number', message: '排序值必须为数字值' }
                ],
            },
            data: {
                units: [],
                searchUnits: [],
                emps: [],
            },
            //搜索栏数据
            query: {
                unId: "00000000-0000-0000-0000-000000000000", //单位信息
                name: "", //模糊字段
            },
            //分页栏数据
            xpagination: {
                totalCount: 1,
                pageSize: 10,
                pageNumber: 1,
                totalPages: 1,
            },
        };
    },
    methods: {
        //判断勾选
        selectable(row, index) {
            if (row.isManager) {
                return false;
            } else {
                return true;
            }
        },
        indexMethod(index) {
            return this.xpagination.pageSize * (this.xpagination.pageNumber - 1) + index + 1;
        },
        handleCurrentChange(val) {
            this.xpagination.pageNumber = val;
            this.getEmployes();
        },
        formReturn() {
            this.$router.push("Supers");
        },
        queryEmps() {
            this.xpagination.pageNumber = 1;
            this.getEmployes();
        },
        getEmployes() {
            const unId = this.query.unId
            const name = this.query.name;
            const pageIndex = this.xpagination.pageNumber;
            const pageSize = this.xpagination.pageSize;
            this.userApi
                .getPlatformList(unId, name, pageIndex, pageSize)
                .then((resp) => {
                    //读取成功
                    // console.log(resp.data);
                    this.data.emps = resp.data;
                    //字符串转json
                    var pagin = JSON.parse(resp.headers.xpagination);
                    this.xpagination.totalCount = parseInt(pagin.totalCount);
                    this.xpagination.pageSize = parseInt(pagin.pageSize);
                    this.xpagination.currentPage = parseInt(pagin.currentPage);
                    this.xpagination.totalPages = parseInt(pagin.totalPages);
                })
                .catch((error) => {
                    var message = error.response.data.Message;
                    if (message == null) {
                        message = "服务器访问失败";
                    }

                    this.$toast(message);
                });
        },
        getUnitAll() {
            this.userApi.getUnitAll()
                .then((resp) => {
                    // console.log(resp.data)
                    this.data.units = resp.data
                    this.data.searchUnits = [
                        {
                            id: "00000000-0000-0000-0000-000000000000",
                            name: "全部单位"
                        }
                    ]
                    this.data.searchUnits = this.data.searchUnits.concat(resp.data)
                })
        },
        //添加新记录
        createDlgShow() {
            this.createDialog.dlgVisible = true
        },
        //创建新用户
        createUser(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //alert('submit!');
                    const name = this.createDialog.name
                    const phone = this.createDialog.phone
                    const unId = this.createDialog.unId
                    const description = this.createDialog.description
                    const orderNum = this.createDialog.orderNum
                    this.userApi.createUser(name, phone, unId, description, orderNum)
                        .then((resp) => {
                            // console.log(resp)
                            if (resp.status == 200) {
                                this.createDialog.dlgVisible = false
                                this.getEmployes()
                            }
                        })
                        .catch(() => {
                            this.$toast("创建失败");
                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        updateDlgShow(row) {
            //console.log(row)
            this.updateDialog.uid = row.id
            this.updateDialog.name = row.name
            this.updateDialog.phone = row.phone
            this.updateDialog.unId = row.unitId
            this.updateDialog.description = row.officeName
            this.updateDialog.category = row.category
            this.updateDialog.orderNum = row.orderNum
            this.updateDialog.roles = row.roles.split(",")
            let roles = this.updateDialog.roles
            this.updateDialog.isAdmin = roles.includes("admin")
            this.updateDialog.isSuper = roles.includes("super")
            this.updateDialog.isManager = roles.includes("manager")

            this.updateDialog.dlgVisible = true
        },
        //部分修改用户信息
        updateUser() {
            this.updateDialog.dlgVisible = false
            //[{"op":"replace","path":"/Name","value":"第一完全小学123"}]
            var uid = this.updateDialog.uid
            var name = this.updateDialog.name
            var phone = this.updateDialog.phone
            var unId = this.updateDialog.unId
            var description = this.updateDialog.description
            var orderNum = this.updateDialog.orderNum
            this.userApi.updateUser(uid, name, phone, unId, description, orderNum)
                .then((resp) => {
                    let roles = this.updateDialog.roles
                    const isAdmin = this.updateDialog.isAdmin
                    const isSuper = this.updateDialog.isSuper
                    const isManager = this.updateDialog.isManager
                    roles = roles.filter((item) => item != "admin")
                    roles = roles.filter((item) => item != "super")
                    roles = roles.filter((item) => item != "manager")
                    if (isAdmin) roles = roles.concat(["admin"])
                    if (isSuper) roles = roles.concat(["super"])
                    if (isManager) roles = roles.concat(["manager"])
                    //console.log(roles.join(","))
                    //修改用户角色
                    this.userApi.updateUserRoles(uid, roles.join(","))
                        .then((resp) => {
                            this.getEmployes()
                        })
                        .catch(() => {
                            console.log('用户角色修改失败')
                        })
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast("用户修改失败");
                })
        },
        movetoUser(row) {
            this.$confirm("确定移出该用户吗？", "提示", {
                iconClass: "el-icon-question", //自定义图标样式
                confirmButtonText: "确认", //确认按钮文字更换
                cancelButtonText: "取消", //取消按钮文字更换
                showClose: true, //是否显示右上角关闭按钮
                type: "warning", //提示类型  success/info/warning/error
            })
                .then(() => {
                    //确认操作
                    const uid = row.id;
                    this.userApi
                        .movetoUser(uid)
                        .then((res) => {
                            // console.log(res.data)
                            this.$toast("用户移出成功!");
                            this.getEmployes()
                        })
                        .catch((err) => {
                            var message = err.response.data.Message;
                            if (message == null) {
                                message = "服务器访问失败";
                            }

                            this.$toast(message);
                        });
                })
                .then((data) => {
                    //取消操作
                })
                .catch((err) => {
                    //捕获异常
                    console.log(err);
                });
        },
        resetPassword(row) {
            this.$confirm("确定重置该用户密码吗？", "提示", {
                iconClass: "el-icon-question", //自定义图标样式
                confirmButtonText: "确认", //确认按钮文字更换
                cancelButtonText: "取消", //取消按钮文字更换
                showClose: true, //是否显示右上角关闭按钮
                type: "warning", //提示类型  success/info/warning/error
            })
                .then(() => {
                    //确认操作
                    const uid = row.id;
                    this.userApi
                        .resetPassword(uid)
                        .then((res) => {
                            // console.log(res.data)
                            this.$toast("密码重置为：" + res.data);
                        })
                        .catch((err) => {
                            var message = err.response.data.Message;
                            if (message == null) {
                                message = "服务器访问失败";
                            }

                            this.$toast(message);
                        });
                })
                .then((data) => {
                    //取消操作
                })
                .catch((err) => {
                    //捕获异常
                    console.log(err);
                });
        },
        toMoveUser() {
            this.$router.push({ name: "MoveManager" });
        },
    },
};
</script>

<style lang="less" scoped>
.el-header {
    background-color: #b3c0d1;
    color: #333;
    line-height: 40px;
}

//工具栏样式
.cust_seach {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    width: 100%;
    padding: auto 5px;

    .btnLeft {
        flex: 1;
        margin: 0;

        /deep/ .el-input__inner {
            height: 41px;
            border-radius: 0px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
    }

    .btnTitle {
        flex: 2;
        margin: 0;

        /deep/ .el-input__inner {
            height: 41px;
            border-radius: 0px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
        }
    }

    .btnStatus {
        flex: 1;
        margin: 0;

        /deep/ .el-input__inner {
            height: 41px;
            border-radius: 0px;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
        }
    }

    .el-button-group>.el-button:first-child:last-child {
        border-radius: 0px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
}

.el-select {
    float: left;
}

.cust_pagin {
    display: flex;
    position: sticky;
    bottom: 0;
    z-index: 999;
}

/deep/.el-breadcrumb__separator {
    color: rgb(87, 86, 86);
}

/deep/.el-input.is- .el-input__inner {
    color: #031944;
}

/deep/.el-textarea.is- .el-textarea__inner {
    color: #031944;
}

.headtool {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.miniTool {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

//
.img-list {
    overflow: hidden;
    width: 100%;

    // 文件列表
    .img-li-box {
        float: left;
        text-align: left;
        position: relative;
        display: block; //Inline-block
        width: 200px;
        height: 270px;
        padding: 5px;
        margin: 5px 20px 20px 0;
        border: 1px solid #d1dbe5;
        border-radius: 4px;
        transition: all 0.3s;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

        // 图片
        .img-li-b--url {
            display: block;
            width: 100%;
            height: 190px;
            margin: 0 auto;
            border-radius: 4px;
        }

        // 底部
        .img-li-b--bottom {
            margin-top: 10px;

            // 名称
            .img-li-b--name {
                width: 90%;
                text-overflow: ellipsis;
                overflow: hidden;
                height: 25px;
                line-height: 25px;
            }
        }

        // 删除按钮
        .img-li-b--delete {
            position: absolute;
            bottom: 10px;
            right: 10px;
            color: #8492a6;
            cursor: pointer;
            font-size: 1.1em;
        }

        // 放大遮罩层
        .img-li-b--layer {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 200px;
            color: #fff;
            text-align: center;
            z-index: 5;
            background-color: rgba(0, 0, 0, 0.4);

            // 放大按钮
            i {
                font-size: 1.6em;
                margin-top: 80px;
            }
        }

        .img-li-b--delete,
        .img-li-b--layer {
            opacity: 0;
            transition: all 0.3s;
        }

        // 悬浮可见删除 or 放大按钮
        &:hover {

            .img-li-b--delete,
            .img-li-b--layer {
                opacity: 1;
            }
        }

        // 上传进度
        &.img-li-b--progress {
            // padding: 0;
            // text-align: center;
            // padding-top: 0px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    // 上传按钮
    .img-li-b--upload {
        float: left;
        width: 200px;
        height: 270px;
        display: table;
        text-align: center;

        .img-li-b--upl--field {
            width: 100%;
            display: table-cell;
            vertical-align: middle;
        }
    }
}

.el-dialog-div {
    margin: 0 auto;
    height: 500px;
    overflow: auto;
    display: flex;
    align-items: center;
}

/deep/ .el-drawer__body {
    overflow-y: none;
    padding: 5px 5px;
    margin-bottom: 50px;
}

.demo-drawer__footer {
    width: 100%;

    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: center;
    background-color: white;

    .el-button {
        flex: 1;
    }
}
</style>